import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddeSignature from './addesignature/index'
import eSignatureList from './esignaturelist/index'

//auth
import {
    userIsAuthenticatedRedir, userIsNotAuthenticatedRedir,
    userIsAuthenticated, userIsNotAuthenticated, userIsSuperAdminRedir,
    userIsBoardAdminRedir, userIsCommitteeAdminRedir, userIsCheckerAdminRedir
} from '../auth'

const AddeSignatureProtected_ma = userIsCommitteeAdminRedir(AddeSignature)
const eSignatureListProtected_ma = userIsCommitteeAdminRedir(eSignatureList)

const eSignature = ({ match }) => (
    <div className="app-wrapper">
        <Switch>
            {/* Meeting Admin */}
            <Redirect exact from={`${match.url}/`} to={`${match.url}/esignature-list`} />
            <Route path={`${match.url}/add-esignature/:id?`} component={AddeSignatureProtected_ma} />
            <Route path={`${match.url}/esignature-list/:id?`} component={eSignatureListProtected_ma} />
        </Switch>
    </div>
);

export default eSignature;



// WEBPACK FOOTER //
// ./app/esignaturedetails/index.js